import React from 'react';
import { TextField, IconButton, InputAdornment, alpha } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

/**
 * Componente de campo de busca reutilizável
 * @param {Object} props - Propriedades do componente
 * @param {string} props.value - Valor atual do campo
 * @param {Function} props.onChange - Função chamada quando o valor muda
 * @param {Function} props.onClear - Função chamada para limpar o campo
 * @param {string} props.placeholder - Texto de placeholder
 * @param {Object} props.customTheme - Tema personalizado
 * @returns {JSX.Element}
 */
const SearchField = ({
  value,
  onChange,
  onClear,
  placeholder = "Buscar...",
  customTheme
}) => {
  return (
    <TextField
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClear} edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          borderRadius: '10px',
          backgroundColor: theme => theme.palette.mode === 'dark' 
            ? alpha(customTheme.palette.common.white, 0.05)
            : alpha(customTheme.palette.common.black, 0.03),
          '&:hover': {
            backgroundColor: theme => theme.palette.mode === 'dark' 
              ? alpha(customTheme.palette.common.white, 0.08)
              : alpha(customTheme.palette.common.black, 0.05),
          }
        }
      }}
    />
  );
};

export default SearchField; 